import React from 'react';
import { useLocation } from 'react-router-dom';

const LABELS = {
  '/ventas':         'Ventas',
  '/cuentas-cobrar': 'Cuentas por Cobrar',
  '/roles':          'Roles',
  '/empresas':       'Gestión de Empresas',
};

export default function ProximamentePage() {
  const { pathname } = useLocation();
  const label = LABELS[pathname] || 'Módulo';

  return (
    <div style={{ padding: '3rem', textAlign: 'center', color: '#6b7280' }}>
      <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🚧</div>
      <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '0.5rem', color: '#374151' }}>
        {label}
      </h2>
      <p style={{ fontSize: '0.95rem' }}>Este módulo está en desarrollo y estará disponible próximamente.</p>
    </div>
  );
}
